import { AccountCapabilities, decodeCapabilities } from './capabilities-decoder'
import { getOidc } from '@/features/oidc/oidc'

export const getAccountCapabilities =
  async (): Promise<AccountCapabilities> => {
    const oidc = await getOidc()

    if (oidc.isUserLoggedIn) {
      return decodeCapabilities(oidc.getDecodedIdToken()['pam-cid'])
    }

    // if player is not logged in it has no capabilities
    return decodeCapabilities(0n)
  }
